package org.example.personalwebsite.util

import com.varabyte.kobweb.compose.ui.graphics.Color

object Res {

    enum class Theme(val color: Color) {
        BLUE(color = Color.rgb(r = 33, g = 150, b = 243)),
        LIGHT_BLUE(color = Color.rgb(r = 168, g = 236, b = 255)),
        DARK_BLUE(color = Color.rgb(r = 34, g = 63, b = 94)),
        SOCIAL_ICON_BACKGROUND_LIGHT(color = Color.rgb(r = 230, g = 230, b = 230)),
        SOCIAL_ICON_BACKGROUND_DARK(color = Color.rgb(r = 48, g = 82, b = 118)),
        GRADIENT_ONE(color = Color.rgb(r = 161, g = 196, b = 253)),
        GRADIENT_ONE_DARK(color = Color.rgb(r = 19, g = 38, b = 58)),
        GRADIENT_TWO(color = Color.rgb(r = 194, g = 233, b = 251)),
        GRADIENT_TWO_DARK(color = Color.rgb(r = 20, g = 46, b = 73))
    }

    object Icon {
        const val EMAIL = "mail.svg"
        const val EMAIL_LIGHT = "mail_light.svg"
        const val GITHUB = "github.svg"
        const val GITHUB_LIGHT = "github_light.svg"
        const val INSTAGRAM = "instagram.svg"
        const val INSTAGRAM_LIGHT = "instagram_light.svg"
        const val GITLAB = "gitlab.svg"
        const val GITLAB_LIGHT = "gitlab_light.svg"
        const val SUN = "sun.svg"
        const val MOON = "moon.svg"
    }

    object Image {
        const val PROFILE_PHOTO = "photo.jpg"
        const val PROFILE_PHOTO_2 = "photo2.jpeg"
        const val PROFILE_PHOTO_3 = "photo3.jpg"
    }

    object String {
        const val NAME = "Muhammad Sultan"
        const val PROFESSION = "Kotlin Multiplatform Developer"
        const val ABOUT_ME =
            "Muhammad Sultan | Kotlin Multiplatform Developer I am a Software Engineer and Android Developer specializing in Jetpack Compose and Kotlin. With over 2 years of industry experience, I currently build enterprise management systems (WMS, POS, AMS) at EmergTech. I focus on Clean Architecture (MVVM) and high-performance mobile solutions."
        const val BUTTON_TEXT = "Get in touch"
        const val ROBOTO_CONDENSED = "RobotoCondensedBold"
        const val ROBOTO_REGULAR = "RobotoRegular"
        const val SAVED_THEME = "theme"
        const val MY_EMAIL = "mailto:zunaidsultan786@gmail.com"
        const val MY_GITHUB = "https://github.com/Zuanid-Sutlan"
        const val MY_GITLAB = "https://gitlab.com"
        const val MY_INSTAGRAM = "https://www.instagram.com"
    }

    object Dimens {
        const val BORDER_RADIUS = 8
        const val MAX_CARD_WIDTH = 1000
        const val MAX_CARD_HEIGHT = 600
        const val ICON_SIZE = 24
        const val ICON_SIZE_LG = 32
    }
}